export default "__VITE_ASSET__CrBJAGH6__"